import { Injectable } from '@angular/core';
import { Platform, PopoverController, ToastController } from '@ionic/angular';
import { environment } from "src/environments/environment";
import { BrowserShareComponent, SharedsType } from '../components/browser-share/browser-share.component';
import { UserService } from '../shared-lib/domains/user';


export interface SharedData {

  title: string;
  message: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShareService {


  cartRef: string = '/cart?orderId=';

  title = `te ha compartido su carrito y documentos en COPYFLY`;
  anonimousTitle = "Te comparto mi carrito y documentos en COPYFLY";

  msg = {
    l1: `Te dejo mi carrito con todos mis archivos listos para imprimir en *COPYFLY*.`,
    l2: `Pincha en el enlace y si lo necesitas puedes añadir o quitar archivos para completar tu pedido.`
  };

  href = environment.url[0] + '//' + environment.url[2] + this.cartRef;


  defaultShare: SharedData = {
    title: this.title,
    message:
      `${this.msg.l1}

${this.msg.l2}
`,
    url: this.href
  };

  constructor(
    private popoverController: PopoverController,
    public toastController: ToastController,
    private userService: UserService,
    public platform: Platform
  ) {
  }


  //Compartes la orden
  public shareOrder(orderId: string): void {

    let title = 'p';

    if (!!this.userService.userG.id) {
      title = this.userService.userG.displayName + ' ' + this.title;
      // Te comparto mi carrito y documentos en COPYFLY
    } else {
      title = this.anonimousTitle;
    }

    const sharedData: SharedData = {
      title: title,
      message:
        `${this.msg.l1}

${this.msg.l2}

${this.href + orderId}
`,
      url: this.href + orderId
    };

    const nav: any = navigator; //ignores terminal issue
    if (this.platform.is('mobile')) {
      this.shareBrowserMobile(sharedData, nav);
    } else {
      this.shareBrowserDesktop(sharedData);
    }
  }

  private async shareBrowserMobile(sharedData: SharedData, nav): Promise<void> {

    const shareMsg = {
      'title': sharedData.title,
      'text': this.defaultShare.message,
      'url': sharedData.url
    };
    await nav.share({ ...shareMsg })
      .then(() => {
      }).catch(error => {
        console.log('Error sharing:', error);
      });
  }

  private async shareBrowserDesktop(sharedData: SharedData): Promise<void> {
    const popover = await this.popoverController.create({
      component: BrowserShareComponent,
      cssClass: ' popup-browser-share ',
    });
    await popover.present(); //muestra el popover
    await popover.onDidDismiss().then(info => {
      if (!!info.data) {
        this.shareType(info.data, sharedData);
      }
    });
  }

  private shareType(type: string, sharedData: SharedData): void {

    switch (type) {
      case SharedsType.WHATSAPP:

        let wspCode = encodeURIComponent(sharedData.message);

        var openedWindow = window.open(
          'https://api.whatsapp.com/send?text=' + wspCode,
          '_blank'
          // 'height=350,width=600'
        );
        if (openedWindow.focus) {
          openedWindow.focus();
        }

        break;
      case SharedsType.MAIL:

        const mail_title = encodeURIComponent(sharedData.title);
        const mail_body = encodeURIComponent(sharedData.message);

        var openedWindow = window.open(
          `mailto:?subject=${mail_title}&body=${mail_body}`,
          '_blank',
          // 'height=1,width=1'
        );
        break;
      case SharedsType.COPY:
        //FIXME  NO ESTÁ FUNCIONANDO EN SAFARI 
        //NI CON NAVIGATOR NI CREANDO EL INPUT SIN EMBARGO EN EMBAJADORES EL COPY FUNCIONA BIEN
        var clipboardCopy = navigator.clipboard.writeText(sharedData.url);
        clipboardCopy
          .then(() => {
            this.showToast();
          })
          .catch((err) => {
            console.log("Err", err);
            let element = document.createElement('input');
            element.value = sharedData.url;
            document.body.appendChild(element);
            element.focus();
            element.select();
            document.execCommand('copy');
            document.body.removeChild(element);
            this.showToast();
          });
        break;
      default:
        console.error("Tipo incorrecto en shareType");
        break
        ;
    }

  }


  async showToast() {

    const toast = await this.toastController.create({
      message: 'Enlace copiado',
      duration: 2500,
      color: "dark"
    });
    toast.present();


  }
}
